<div class="ukb" *ngIf="allapot">
  <div class="ukb-fej">
    <b>Ügyfélkör</b>
    <span class="ukb-cimke" [class.onallo]="allapot.mod === 'onallo'">{{ modNev(allapot.mod) }}</span>
  </div>
  <p class="ukb-sugo">
    <ng-container *ngIf="allapot.naplo_aktiv">A Könyvelés aktív ebben az intézményben, ezért alapból kapcsolt: az ügyfelek onnan jönnek, újat ott kell felvenni.</ng-container>
    <ng-container *ngIf="!allapot.naplo_aktiv">A Könyvelés nem aktív ebben az intézményben, ezért a modul önállóan, saját ügyfélkörrel működik.</ng-container>
    Váltáskor az ügyfelek ugyanazzal az azonosítóval kerülnek át, az adataik megmaradnak.
  </p>
  <div class="ukb-sor">
    <label><input type="radio" name="ukb-{{ alrendszer }}" value="auto" [(ngModel)]="valasztott"> Automatikus ({{ allapot.auto === 'kapcsolt' ? 'kapcsolt' : 'önálló' }})</label>
    <label [class.tiltott]="!allapot.naplo_aktiv"><input type="radio" name="ukb-{{ alrendszer }}" value="kapcsolt" [(ngModel)]="valasztott" [disabled]="!allapot.naplo_aktiv"> Kapcsolt</label>
    <label><input type="radio" name="ukb-{{ alrendszer }}" value="onallo" [(ngModel)]="valasztott"> Önálló</label>
    <button type="button" class="ukb-gomb" (click)="ment()" [disabled]="fut || valasztott === (allapot.beallitott || 'auto')">{{ fut ? 'Mentés…' : 'Mentés' }}</button>
  </div>
  <div class="ukb-ok" *ngIf="uzenet">{{ uzenet }}</div>
  <div class="ukb-hiba" *ngIf="hiba">{{ hiba }}</div>
</div>
